<app-viewport-guard />
<app-loader />
<app-error-modal />
<div class="route-container" [@routeAnimation]="prepareRoute(outlet)">
  <router-outlet #outlet="outlet" />
</div>
